import React, { FC, useCallback, useMemo } from 'react'
import { Input } from '@wmgtech/legato'
import debounce from 'lodash/debounce'

import styles from './ArtistsHeader.module.scss'

const ArtistsHeader: FC<{ loading: boolean; onSearch: (name: string) => void; }> = ({ loading, onSearch }) => {
  const onChangeSearchName = useCallback((value: string) => onSearch(value), [onSearch])

  const debounceSearch = useMemo(() => debounce(onChangeSearchName, 100), [onChangeSearchName])

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => debounceSearch(e.target.value)

  return (
    <div className={styles.container}>
      <Input
        crossOrigin
        onChange={onChange}
        className={styles.search}
        placeholder="Search for Artist"
        containerStyle="outline"
        validation={{ pending: loading }}
        suffixIcon="magnifying-glass"
      />
    </div>
  )
}

export default ArtistsHeader
